// TODO @consumer: Rewrite PhotoObfuscated and replace it in this component.
// TODO @consumer: Rewrite "DownloadPhotoButton" and probably convert to hook.

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useHistory } from 'react-router-dom';

import { IMAGE_SIZE_CODE } from '../../../../../../../constants/image-size-codes';
import PhotoObfuscated from '../../../../../../../components/global/obfuscation/PhotoObfuscated';
import Badge from '../../../../../../../components/global/Badge';
import { getFaceboxes } from './helpers';

const propTypes = {
  matchedPhoto: PropTypes.shape({
    id: PropTypes.string.isRequired,
    photo: PropTypes.shape({
      id: PropTypes.string.isRequired,
      thumbnail_urls: PropTypes.arrayOf(
        PropTypes.shape({
          url: PropTypes.string,
          width: PropTypes.number,
          height: PropTypes.number,
          size_code: PropTypes.oneOf(Object.values(IMAGE_SIZE_CODE)),
        }),
      ),
      price_album_folder_tag: PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        digital_downloads_price: PropTypes.shape({
          value: PropTypes.number.isRequired,
        }).isRequired,
      }),
      attribution: PropTypes.shape({
        name: PropTypes.string,
        username: PropTypes.string,
        avatar_photo: PropTypes.shape({
          thumbnail_urls: PropTypes.array,
        }),
      }),
    }).isRequired,
  }).isRequired,
  isEntitled: PropTypes.bool.isRequired,
  actions: PropTypes.node,
  isAllPhotos: PropTypes.bool,
  includeTagName: PropTypes.bool,
  linkTo: PropTypes.string,
  withWatermark: PropTypes.bool,
  className: PropTypes.string,
};

const MatchedPhoto = ({
  matchedPhoto,
  isEntitled,
  actions,
  isAllPhotos,
  includeTagName = true,
  linkTo,
  withWatermark,
  className,
}) => {
  const history = useHistory();
  const { id, photo } = matchedPhoto;
  const tagName = matchedPhoto.price_album_folder_tag?.name;
  const faceboxes = getFaceboxes(matchedPhoto, !isAllPhotos);

  return (
    <div
      className={classNames({
        'matched-grid-photo': true,
        'has-bottom-elements': includeTagName && tagName,
        [className]: !!className,
      })}
    >
      <PhotoObfuscated
        id={id}
        thumbs={
          withWatermark
            ? photo.watermarked_urls ?? photo.thumbnail_urls
            : photo.thumbnail_urls
        }
        faceboxes={faceboxes}
        obfuscatorMultiplier={isEntitled || isAllPhotos ? 0 : 1.8}
        blockerMinSizeThreshold={0.005}
        blockerMinSize={0.3}
        blockerMaxSize={0.5}
        minThumbnailSize={IMAGE_SIZE_CODE.MEDIUM2X}
        maxThumbnailSize={
          // On FWG, non-entitled items must show on medium res.
          !isEntitled && isAllPhotos
            ? IMAGE_SIZE_CODE.MEDIUM2X
            : IMAGE_SIZE_CODE.LARGE
        }
        onClick={
          (isEntitled || isAllPhotos) && linkTo
            ? () => history.push(linkTo)
            : undefined
        }
      />

      {actions && <div>{actions}</div>}

      {includeTagName && tagName && (
        <Badge
          className="matched-grid-photo-tag"
          badgeStyle="dark-transparent-light"
        >
          {tagName}
        </Badge>
      )}
    </div>
  );
};

MatchedPhoto.propTypes = propTypes;

export default MatchedPhoto;
